
import React from "react";
import {checkReplaceUrl} from '../../utils'

const CategoryCard = ( props) => {
    console.log(props?.isApiLoading, 'isApiLoading');
    
    return (
        <React.Fragment >

            {!props?.isApiLoading && (
                <div role="button" className="sd-text-left sd-cursor-pointer" onClick={props?.onClick}>
                    <div className="sd-bg-gray-300 sd-w-full sd-rounded-xs sd-flex sd-items-center sd-justify-center sd-my-2 sd-h-[200px]">
                        <img className="sd-mx-auto sd-p-1 sd-object-contain sd-w-full sd-h-full" src={checkReplaceUrl(props?.imageUrl)} alt={props?.title}  />
                    </div>
                    <h3>{props?.title}</h3>
                </div>
            )}
            {props?.isApiLoading && (
                <div className="sd-text-left sd-flex sd-flex-col  sd-cursor-pointer" >
                    <div className="sd-bg-gray-300 sd-w-auto sd-rounded-xs sd-flex sd-items-center sd-animate-pulse  sd-justify-center sd-my-2">
                        <div className="sd-mx-auto sd-h-[289px] sd-w-auto"></div>
                    </div>
                    <h3 className="sd-w-[60%] sd-bg-gray-300 sd-animate-pulse">
                        <div className=" sd-h-[16px]"></div>
                    </h3>
                </div>
            )}
        </React.Fragment >
    );
};

export default CategoryCard;